import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { SubscriptionModel } from "@/features/common/api/useSubscription";

export interface SubscriptionDeleteRequestModel {
	readonly cancellationReason: string;
}

export const useSubscriptionDelete = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse, SubscriptionDeleteRequestModel> = requestModel => {
		return http<undefined, SubscriptionDeleteRequestModel>({
			method: "POST",
			url: "/subscription/delete",
			body: requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.setQueryData(["subscription"], (oldData: SubscriptionModel | undefined) => {
				if (!oldData) {
					return oldData;
				}

				return {
					...oldData,
					autoRenewPaymentCardId: null,
					autoRenewPlanId: null,
					autoRenewPlanName: null
				};
			});
		}
	});
};
